import { __assign } from "tslib";
import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
import ExcerptRenderer from './ExcerptRenderer';
import BaseViewer from '../DaEditorWrapper/Viewer/Base';
import ErrorBoundary from '../ErrorBoundary';
import WrapWidth from './WrapWidth';
var TextRenderer = React.forwardRef(function (_a, ref) {
    var textContent = _a.textContent, className = _a.className, _b = _a.fallbackToExcerpt, fallbackToExcerpt = _b === void 0 ? true : _b, reactViewer = _a.reactViewer, htmlExcerptLegacy = _a.htmlExcerptLegacy, isPollWithHtmlExcerpt = _a.isPollWithHtmlExcerpt, width = _a.width, legacyTheme = _a.legacyTheme, excerptOnly = _a.excerptOnly, viewerKey = _a.viewerKey, disableStylesForLegacy = _a.disableStylesForLegacy, _c = _a.emptyPlaceHolder, emptyPlaceHolder = _c === void 0 ? '' : _c, fixedParagraph = _a.fixedParagraph, draftjsThemeOverride = _a.draftjsThemeOverride, disableLazyLoading = _a.disableLazyLoading;
    if (!textContent) {
        return null;
    }
    var type = get(textContent, 'html.type');
    var markup = get(textContent, 'html.markup');
    if (!markup || excerptOnly) {
        if (!fallbackToExcerpt) {
            return null;
        }
        return (React.createElement(ExcerptRenderer, { textContent: textContent, className: className, emptyPlaceHolder: emptyPlaceHolder, legacyTheme: legacyTheme, htmlExcerptLegacy: htmlExcerptLegacy, isPollWithHtmlExcerpt: isPollWithHtmlExcerpt, disableStylesForLegacy: disableStylesForLegacy, ref: ref }));
    }
    switch (type) {
        case 'writer':
            return (React.createElement(WrapWidth, { width: width, ref: ref },
                React.createElement(LegacyTextRenderer, { className: className, html: markup, theme: legacyTheme, disableStyles: disableStylesForLegacy })));
        case 'draft':
            var Viewer = reactViewer || BaseViewer;
            // do not add theme when not asked for
            var viewerTheme = draftjsThemeOverride
                ? { theme: draftjsThemeOverride }
                : {};
            try {
                return (React.createElement(ErrorBoundary, { debugComponent: "TextRenderer" },
                    React.createElement(WrapWidth, { width: width, ref: ref },
                        React.createElement("div", { className: className },
                            React.createElement(Viewer, __assign({ key: viewerKey, content: JSON.parse(markup), fixedParagraph: fixedParagraph, disableLazyLoading: disableLazyLoading }, viewerTheme))))));
            }
            catch (e) {
                return null;
            }
        default:
            return null;
    }
});
TextRenderer.displayName = 'TextRenderer';
export default TextRenderer;
//# sourceMappingURL=TextRenderer.js.map